define.alias("ember-math-helpers/helpers/mult", "settings/helpers/mult");